module.exports = __webpack_public_path__ + "f5c887855886d865642895e7748094da.pdf";